<div>
  <div class="cursor-default select-none text-md text-(color:--text-secondary) flex flex-row items-center gap-(--gap-tight)">
    {{ label }}
    @if (tooltip) {
      <i class="pi pi-info-circle text-sm cursor-help" [pTooltip]="tooltip" tooltipPosition="top"></i>
    }
  </div>
  <div class="text-(color:--text-primary) flex flex-row items-center gap-(--gap-tight)">
    @if (chips && chips.length > 0) {
      <div class="flex flex-row gap-(--gap-normal) mt-(--space-1) flex-wrap">
        @for (chip of chips; track $index) {
          <p-chip class="cursor-default chip-xs">{{ chip }}</p-chip>
        }
      </div>
    } @else if (type === 'frequency' && value !== undefined) {
      {{ FrequencyUtils.getFrequencyDisplay(value) | transloco }}
    } @else if (type === 'boolean' && booleanValue !== undefined) {
      {{ booleanValue ? ('common.buttons.yes' | transloco) : ('common.buttons.no' | transloco) }}
    } @else {
      <div class="whitespace-pre-wrap">
        <ng-content />
      </div>
    }
  </div>
</div>
